import { UserIcon } from '@heroicons/react/20/solid';

import { UserAvatar } from 'src/shared/components';

const getExampleItemCreator = (item: any) => {
  if (item?.producer_user?.username)
    return (
      <div className="flex items-center gap-1">
        <UserAvatar
          name={item?.producer_user?.username}
          image={item?.producer_user?.avatar_url ?? undefined}
          size="xs"
        />
        <span>{item?.producer_user?.username}</span>
      </div>
    );

  if (item?.producer_supplier_cloak) {
    return (
      <div className="flex items-center gap-1">
        <UserIcon className="size-4" />
        <span>{item?.producer_supplier_cloak}</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1">
      <UserAvatar name="Cavela" image="/images/defaultCavela.svg" size="xs" />
      <span>Cavela</span>
    </div>
  );
};

export default getExampleItemCreator;
